<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Store Type</h1>
    <storeTypeTable />
  </v-card>
</template>

<script>
import storeTypeTable from "@/components/back-office/StoreManagement/StoreType/StoreTypeTable.vue";

export default {
  components: {
    storeTypeTable
  },
  destroyed() {
    this.$store.commit("fetchStoreBack/resetStateStoreType");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage"
      },
      {
        text: "Store Type list",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storetypelist"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
